module.exports = __webpack_public_path__ + "media/images/drop-call-icon-popup-dc199bb8836aa8fc667f3ea3a07a433e.svg";